import axios from "axios";
import { baseUrl } from "../../api/baseUrl";
// import toast from "react-hot-toast";

export const apiInstance = axios.create({
  baseURL: baseUrl,
});
 
